<template>
  <div class="tab-modal tab-modal_sm">
    <div class="tab-modal__close-icon" @click="hide('dc-tab-modal')">
      <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path clip-rule="evenodd"
              d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z"
              fill="#081C15" fill-rule="evenodd"/>
      </svg>
    </div>
    <div class="tab-modal__title">
      {{ mainVar.langs.model.title[mainVar.current_lang] }}
    </div>
    <div class="tab-modal__p mt-4 mb-3">
      {{ mainVar.langs.model.description[mainVar.current_lang] }}
    </div>
    <div v-if="mainVar.langs.model.points.items.length" class="tab-modal__p mb-3">
      <strong>
        {{ mainVar.langs.model.points.title[mainVar.current_lang] }}
      </strong>
    </div>
    <ul v-if="mainVar.langs.model.points.items.length" class="tab-modal__ul">
      <li
        v-for="(item, index) in mainVar.langs.model.points.items"
        :key="index"
      >
        {{ item[mainVar.current_lang] }}
      </li>
    </ul>
    <div class="tab-modal__btns row_sm row justify-content-between mt-4">
      <div class="col-12 col-sm-auto">
        <a
          class="dc-btn dc-btn_outline-primary dc-btn_size-md"
          href="#"
          @click.prevent="closeAndGoToHome('dc-tab-modal')"
        >
          {{ mainVar.langs.model.no_button[mainVar.current_lang] }}
        </a>
      </div>
      <div class="col-12 col-sm-auto">
        <a
          class="dc-btn dc-btn_primary dc-btn_size-md"
          href="#"
          @click.prevent="hide('dc-tab-modal')"
        >
          {{ mainVar.langs.model.yes_button[mainVar.current_lang] }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalContent',
  props: {
    mainVar: {
      type: Object,
      required: true
    }
  },
  methods: {
    hide(modal) {
      this.$modal.hide(modal)
    },
    closeAndGoToHome(modalName) {
      this.hide(modalName)
      window.location.href = admin.url
    },
  }
}
</script>


<style lang="scss">
@import "../../../sass/components/content.scss";
</style>
